(function () {
    'use strict';
    var m = angular.module('configuration');
    m.controller('ApAvananBlacklistController', ["$scope", "$q", "widgetSettings", "apAvananExceptionsDao", "tablePaginationHelper", "defaultListConverter", "modulesManager", "modals", "columnsHelper", "apExceptionsModal", "sideMenuManager", function ($scope, $q, widgetSettings, apAvananExceptionsDao, tablePaginationHelper, defaultListConverter, modulesManager, modals, columnsHelper, apExceptionsModal, sideMenuManager) {
        $scope.initializing = true;
        var constantColumns = [{
                id: 'entity_id',
                primary: true,
                hidden: true
            }];
        $scope.options = {
            columns: [],
            options: {
                defaultOrdering: {
                    columnName: 'entity_id',
                    order: 'desc'
                },
                checkboxes: true
            }
        };
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            saveState: true,
            headerOptions: { enum: { multiple: true } },
            pagination: {
                pageSize: 10,
                ordering: {}
            },
            dropdownHeader: true,
            actions: [{
                    label: 'Remove',
                    display: 'button',
                    active: function () {
                        return $scope.tableHelper.getSelectedIds().length > 0;
                    },
                    execute: function () {
                        var selectedEntities = $scope.tableHelper.getSelectedIds();
                        var confirmMessage = 'Are you sure you want to remove the following rule' + (selectedEntities.length > 1 ? 's' : '') + ' from the Block-List rules?';
                        var rememberMessage = 'rescan emails that were caught by selected rule' + (selectedEntities.length > 1 ? 's' : '');
                        // check if the selected entities have any entity with the "with links to domains" field
                        var dontRescan = false;
                        var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                        var withLinksToDomainsColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'with_links_to_domains');
                        if (_($scope.tableModel.data).findIndex(function (line) {
                                return line && line[primaryColumn].originalText && _(selectedEntities).findIndex(function (entityId) {
                                    return entityId === line[primaryColumn].originalText;
                                }) !== -1 && line[withLinksToDomainsColumnIdx].originalText;
                            }) !== -1) {
                            dontRescan = true;
                        }
                        var confirmParams = {
                            title: 'Confirmation dialog',
                            message: confirmMessage,
                            okText: 'Ok',
                            cancelText: 'Cancel'
                        };
                        if (!dontRescan) {
                            confirmParams.remember = rememberMessage;
                            confirmParams.rememberDefault = true;
                        }
                        return modals.confirm(confirmParams).then(function (data) {
                            return apAvananExceptionsDao.removeBlacklistItems({
                                ids: selectedEntities,
                                rescan: data.remember || false
                            }).then(function () {
                                $scope.tableHelper.clearSelection();
                                $scope.tableHelper.reload();
                            });
                        });
                    }
                }]
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            var params = columnsHelper.filtersToParams(args.columnsFilters);
            var result = apAvananExceptionsDao.blacklist().params(params);
            return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(function (response) {
                $scope.options.columns = constantColumns.concat(_(response.data.labels).chain().map(function (info, id) {
                    return {
                        id: id,
                        text: info.label,
                        order: info.order
                    };
                }).sortBy('order').map(function (col) {
                    return {
                        id: col.id,
                        text: col.text,
                        converter: standardConverter
                    };
                }).value());
                return $q.when(response);
            }).converter(defaultListConverter, function (preFetches) {
                return { columns: $scope.options.columns };
            });
        }, function (tableModel) {
            $scope.initializing = false;
            $scope.tableModel = tableModel;
            $scope.tableOptions.infoText = 'Total Block-List rules found: ' + $scope.tableHelper.getTotal();
        });
        if (sideMenuManager.currentUser().admin) {
            modulesManager.init().then(function () {
                $scope.enabledSaases = _(modulesManager.activeSaasApps()).map(function (saas) {
                    return saas.name;
                });
                var googleActive = $scope.enabledSaases.includes('google_mail');
                var office365Active = $scope.enabledSaases.includes('office365_emails');
                if (office365Active) {
                    $scope.tableOptions.actions.push({
                        label: 'Add Outlook Block-List Rule',
                        display: 'button',
                        execute: function () {
                            return apExceptionsModal.show({
                                type: 'blacklist',
                                entityType: 'office365_emails_email',
                                isNew: true
                            }).then(function () {
                                $scope.tableHelper.reload();
                            });
                        }
                    });
                }
                if (googleActive) {
                    $scope.tableOptions.actions.push({
                        label: 'Add Gmail Block-List Rule',
                        display: 'button',
                        execute: function () {
                            return apExceptionsModal.show({
                                type: 'blacklist',
                                entityType: 'google_mail_email',
                                isNew: true
                            }).then(function () {
                                $scope.tableHelper.reload();
                            });
                        }
                    });
                }
            });
        }
        function standardConverter(text, columnId, columnsMap, args, allConverters) {
            return '#' + JSON.stringify({
                display: 'text',
                text: text,
                clickEvent: {
                    name: 'view-blacklist',
                    id: columnsMap.entity_id,
                    columns: columnsMap
                },
                'class': 'link-like'
            });
        }
        $scope.$on('view-blacklist', function (event, data) {
            return apExceptionsModal.show({
                blacklistId: data.id,
                type: 'blacklist',
                columns: data.columns
            }).then(function () {
                $scope.tableHelper.reload();
            });
        });
    }]);
}());